import { validationUuidEasy } from '../lib/tools';

const appInitialState = {
  activated: false,
  errorCode: '',
  activationCode: '',
  formatError: false,
  hasError: true,
};

export default (state = appInitialState, action) => {
  switch (action.type) {
    case 'DEFAULT': {
      return { ...state, activated: false };
    }
    case 'CHECK_UUID': {
      const caller = action.caller || 'input';
      const activationCode =
        caller === 'input' ? action.param : state.activationCode;
      const formatError = validationUuidEasy(activationCode);
      const hasError = formatError;
      return { ...state, activationCode, formatError, hasError };
    }
    case 'SUCCESS_API_ACTIVATE': {
      return { ...state, activated: true };
    }
    case 'ERROR_API_ACTIVATE': {
      const errorCode =
        (action.payload.errorCode && `${action.payload.errorCode}`) || '';
      return { ...state, errorCode };
    }
    default:
      return state;
  }
};
